module.exports = __webpack_public_path__ + "img/panel_banner.1263aca5.png";